import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import { GridOffset } from "@insite/mobius/GridContainer";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

defaultShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: center;
    `,
};
defaultShippingAddressStyles.editLink = {
    css: css`
        margin-left: 10px;
        font-size: 15px;
    `,
};
defaultShippingAddressStyles.headingText = {
    variant: "h3",
    size: 15,
    css: css`
        margin-bottom: 0;
    `,
};

defaultShippingAddressStyles.gridContainer = {
    gap: 5,
    css: css`
        > ${GridOffset} {
            width: 100%;
            margin: 0;
        }
    `,
};
